import React from "react";

import "../../assets/styles/CookieWall.css";

import logoImage from "../../assets/images/logo@2x.png";
import peterCookiesImage from "../../assets/images/peter-cookies@2x.png";

class Analytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anonymized: true
    };
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

/**
 * Handles the CookieWall and addressed the Analalytics component based on
 * the cookies-settings.
 */
export class CookieWall extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      showCookieWall: false,
      showCookieInfo: false,
      allowAdvertisingCookie: true,
      anonymized: true
    };

    this.togglePage = this.togglePage.bind(this);
    this.toggleCookieInfo = this.toggleCookieInfo.bind(this);
    this.toggleAdvertisingCookie = this.toggleAdvertisingCookie.bind(this);
    this.setCookieSettings = this.setCookieSettings.bind(this);
  }

  togglePage() {
    if (this.state.page === 1) {
      this.setState({ page: 2 });
      window.dataLayer.push({
        event: "Cookiewall",
        action: "setting-screen"
      });
    } else {
      this.setState({ page: 1 });
      window.dataLayer.push({
        event: "Cookiewall",
        action: "start-screen"
      });
    }
    this.setState({ showCookieInfo: false });
  }

  toggleCookieInfo() {
    window.dataLayer.push({
      event: "Cookiewall",
      action: "AdditionalInfoOpened"
    });

    this.setState({ showCookieInfo: !this.state.showCookieInfo });

    return false;
  }

  toggleAdvertisingCookie() {
    this.setState({
      allowAdvertisingCookie: !this.state.allowAdvertisingCookie
    });
  }

  setCookieSettings() {
    let cookieSettings = {
      functional: true,
      analytical: true,
      advertising: this.state.allowAdvertisingCookie
    };

    let cookieDate = new Date();
    cookieDate.setFullYear(cookieDate.getFullYear() + 20);

    let expires = "expires=" + cookieDate.toUTCString();
    document.cookie = "picnic_cc_version=1; " + expires + "; path=/";
    document.cookie =
      "picnic_cc=" +
      JSON.stringify(cookieSettings) +
      "; expires=Thu, " +
      expires +
      "; path=/";
    this.checkCookie();

    window.dataLayer.push({
      event: "Cookiewall",
      action: "setting"
    });
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  checkCookie() {
    let cookiePicnicCC = this.getCookie("picnic_cc");

    if (cookiePicnicCC !== "") {
      let cookieSettings = JSON.parse(cookiePicnicCC);
      if (cookieSettings.advertising) {
        window.dataLayer.push({
          event: "pageView",
          page: this.props.location.pathname
        });
      }

      this.setState({ showCookieWall: false });
    } else {
      this.setState({ showCookieWall: true });
    }
  }

  componentDidMount() {
    this.checkCookie();
  }

  render() {
    return (
      <div>
        {this.state.showCookieWall && (
          <div>
            <div id="modal" />
            <div id="cookie-modal">
              <div id="cookiepopup">
                <div className="cookies-image">
                  <img src={peterCookiesImage} alt="Picnic cookies" />
                </div>
                <div className="cookie-logo">
                  <img src={logoImage} alt="Picnic" />
                </div>
                <div className="cookiewall">
                  {this.props.content(
                    this.state.page,
                    this.state.showCookieInfo,
                    this.state.allowAdvertisingCookie
                  )}
                </div>
              </div>
            </div>

            <Analytics
              anonymized={this.state.anonymized}
              location={this.props.location}
            >
              {this.props.children}
            </Analytics>
          </div>
        )}
      </div>
    );
  }
}
